<template>
    <v-container class="width">
        <v-row>
            <v-col cols="12">
                <button v-if="!whileUploading" class="float-right my-6"  @click="language"> <p class="margin:3px !important">{{langval}}</p></button>
                <button v-show="uploadSucess" class="float-right my-6"  @click="reload"> <p class="margin:1px !important"><v-icon>mdi-refresh</v-icon></p></button>
            </v-col>
            
        </v-row>
        <div v-if="whileUploading" class="border">
        <v-progress-linear v-model="progress" ></v-progress-linear> 
        <p  style="font-size:20px;">{{ $t("form.fileupload") }} {{this.progress}}{{ $t("form.complete") }}</p>
        <div class="button-group">
                    <v-btn 
                        color="red darken-1"
                        @click="cancelUpload" 
                        class="mr-2"
                    >
                        {{ $t("form.cancel") }}
                    </v-btn>
                </div>
        </div>
        <div v-show="uploadSucess" class="border">
        <qrcode v-show="qrCodeUrl" v-model="qrCodeUrl" ></qrcode>
        <p v-show="uploadName" style="font-size:20px;">
            {{ $t("form.name") }}: {{uploadName}}
        </p>
        <p v-show="uploadAge" style="font-size:20px;">
            {{ $t("form.age") }}: {{uploadAge}}
        </p>
        <p v-show="uploadSex" style="font-size:20px;">
            {{ $t("form.sex") }}: {{uploadSex}}
        </p>
        <p v-show="seqNo" style="font-size:20px;">
            {{ $t("form.seq") }}: {{seqNo}}
        </p>
        <p v-show="expireDay" style="font-size:20px;">
            {{ $t("form.exp") }}: {{expireDay}}
        </p>
        </div>
        <div v-if="!uploadSucess && !whileUploading">
        <div v-if="lang == 'en'">
            <FormulateForm
                name="sp_form"
                v-model="dropboxForm"
                @submit="submitHandler"
                class="login-form"
            >
                <h2 class="form-title">Health report upload</h2>
                <FormulateInput
                type="text"
                name="hospid"
                placeholder="Hospital ID"
                label="Hospital ID"
                validation="required|max:20,length"
                />
                <FormulateInput
                name="patientid"
                type="text"
                label="Patient ID"
                placeholder="Patient ID"
                validation="required|max:50,length"
                />
                <FormulateInput
                name="patientname"
                type="text"
                label="Patient Name"
                placeholder="Patient Name"
                validation="required|max:50,length"
                />
                <!-- <FormulateInput
                name="patientsex"
                :options="{Male: 'Male', Female: 'Female', Other: 'Other'}"
                type="select"
                placeholder="Patient Sex"
                label="Patient Sex"
                validation="required"
                /> -->
                <!-- <div class="double-wide">
                <FormulateInput
                type="date"
                name="patientbirth"
                label="Patient Birth"
                placeholder="Patient Birth"
                validation="required"
                />
                <FormulateInput
                type="date"
                name="studydate"
                label="Study Date"
                placeholder="Study Date"
                validation="required"
                />
                </div> -->
                <!-- <FormulateInput
                type="text"
                name="studydesc"
                placeholder="Study Description"
                label="Study Description"
                /> -->
                <v-file-input
                ignored
                webkitdirectory directory
                v-model="dropboxForm.imgfiles"
                type="file"
                @change="showImgFiles"
                label="Directory of DICOM files"
                multiple
                ></v-file-input>
                <v-file-input
                ignored
                v-model="dropboxForm.files"
                type="file"
                @change="showFiles"
                label="PDF File"
                multiple
                ></v-file-input>
                <FormulateInput
                type="submit"
                label="Submit"
                :disabled="!isFormValid"
                />
            </FormulateForm>
        </div>
        <div v-else>
            <FormulateForm
                name="sp_form"
                v-model="dropboxForm"
                @submit="submitHandler"
                class="login-form"
            >
                <h2 class="form-title">健康報告上傳</h2>
                <FormulateInput
                type="text"
                name="hospid"
                placeholder="上傳機構"
                label="上傳機構"
                validation="required|max:20,length"
                />
                <FormulateInput
                name="patientid"
                type="text"
                label="身分證號"
                placeholder="身分證號"
                validation="required|max:50,length"
                />
                    <FormulateInput
                    name="patientname"
                    type="text"
                    label="姓名"
                    placeholder="姓名"
                    validation="required|max:50,length"
                    />
                    <!-- <FormulateInput
                    name="patientsex"
                    :options="{Male: '男', Female: '女', Other: '其他'}"
                    type="select"
                    placeholder="性別"
                    label="性別"
                    validation="required"
                    /> -->
                <!-- <div class="double-wide">
                <FormulateInput
                type="date"
                name="patientbirth"
                label="生日"
                placeholder="生日"
                validation="required"
                />
                <FormulateInput
                type="date"
                name="studydate"
                label="檢查日期"
                placeholder="檢查日期"
                validation="required"
                />
                </div>
                <FormulateInput
                type="text"
                name="studydesc"
                placeholder="檢查名稱"
                label="檢查名稱"
                /> -->
                <v-file-input
                ignored
                webkitdirectory directory
                v-model="dropboxForm.imgfiles"
                type="file"
                @change="showImgFiles"
                label="影像檔案"
                multiple
                ></v-file-input>
                <v-file-input
                ignored
                v-model="dropboxForm.files"
                type="file"
                @change="showFiles"
                label="報告檔案"
                multiple
                ></v-file-input>
                <FormulateInput
                type="submit"
                label="提交"
                :disabled="!isFormValid"
                />
            </FormulateForm>
        </div>
        </div>
    </v-container>
</template>
<script>
import axios from 'axios'
export default {
    metaInfo() {
        return { 
            title: "病歷上傳",
            meta: [
                { name: 'description', content:  'Medical Record File Upload'},
            ]
        }
    },
    data () {
        const lang = localStorage.getItem('lang')
        return {
            lang:lang,
            langval:'',
            // compressing:false,
            uploadSucess:false,
            whileUploading:false,
            progress:0,
            qrCodeUrl: "",
            uploadAge:'',
            uploadName:'',
            uploadSex:'',
            expireDay:'',
            seqNo:'',
            dropboxForm:{
                imgfiles:null,
                files:null,
                password:'',
                patientid:'',
                patientname:'',
                patientsex:'',
                patientbirth:'',
                studydate:'',
                studydesc:'',
                hospid:'',
            },
            cancelTokenSource: null,
        }
    },
    async created(){
        let lang = localStorage.getItem('lang')
        lang == 'en' ? this.langval = '中' : this.langval = 'EN'
        if(navigator.language == 'en-US'){
            if(lang =='ch'){
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }else {
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }
        }
        else{
            if(lang =='en'){
                this.$i18n.locale = 'en'
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }else {
            console.log("chinese");
            this.$i18n.locale = 'ch'
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }
        }
    },
    computed: {
        isFormValid() {
            // Check if required form fields are filled AND at least one type of file is present
            return this.dropboxForm.hospid && 
                   this.dropboxForm.patientid && 
                   this.dropboxForm.patientname && 
                   ((this.dropboxForm.files && this.dropboxForm.files.length > 0) || 
                    (this.dropboxForm.imgfiles && this.dropboxForm.imgfiles.length > 0));
        }
    },
    methods:{
    language(){
            console.log(this.langval);
            if(this.langval=='EN'){
                localStorage.setItem('lang','en');
                this.langval='中'
            }
            else{
                localStorage.setItem('lang','ch');
                this.langval='EN'
            }
            window.location.reload()
    },
    showFiles(){
        console.log(this.dropboxForm.files);
    },
    showImgFiles(){
        console.log(this.dropboxForm.imgfiles);
    },
    async submitHandler(){
        this.whileUploading = true
        console.log(this.dropboxForm);
        this.cancelTokenSource = axios.CancelToken.source();
        const config = {
            headers: {"content-type": "multipart/form-data"},
            cancelToken: this.cancelTokenSource.token,
            onUploadProgress: (progressEvent) => {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                this.progress = percentCompleted;
                console.log(this.progress );
                // if(this.progress == 100)
                // {
                // this.compressing =true;
                // }
            }
        };
        if(this.dropboxForm.patientid)
        {
            this.dropboxForm.password = this.dropboxForm.patientid.slice(-4);
        }
        console.log(this.dropboxForm);
        let formData = new FormData();
        if(this.dropboxForm.files)
        {
            for (let i = 0; i < this.dropboxForm.files.length; i++) {  // 每个file append到formdata里
            formData.append('files', this.dropboxForm.files[i])
            }
        }
        if(this.dropboxForm.imgfiles)
        {
            for (let i = 0; i < this.dropboxForm.imgfiles.length; i++) {  // 每个file append到formdata里
            formData.append('imgfiles', this.dropboxForm.imgfiles[i])
            }
        }
        formData.append("password", this.dropboxForm.password)
        formData.append("patientid", this.dropboxForm.patientid)
        formData.append("patientname", this.dropboxForm.patientname)
        formData.append("patientsex", this.dropboxForm.patientsex)
        formData.append("patientbirth", this.dropboxForm.patientbirth)
        formData.append("studydate", this.dropboxForm.studydate)
        formData.append("studydesc", this.dropboxForm.studydesc)
        formData.append("hospid", this.dropboxForm.hospid)
         try {
            const res = await axios.post('PDFUpload',formData, config)
            console.log('files uploaded!', res);
            this.qrCodeUrl= res.data.qrcode;
            this.uploadSex = res.data.pT_SEX;
            this.uploadName = res.data.pT_NAME;
            this.expireDay = res.data.expirE_DAY;
            this.seqNo = res.data.seqno;
            // getting age from birthday
            this.uploadSucess = true;
            this.whileUploading =false;
            // this.compressing =false,
            // console.log(this.uploadName, this.uploadAge,this.uploadSex);
            if(res.data.pT_AGE){
                this.uploadAge = this.calculateAge(res.data.pT_AGE)
            }
            
            } 
        catch (err) {
                this.whileUploading =false
                
                console.log(err.response);
                // alert("Image upload failed. Please try again.")
        }
        
    },
    calculateAge(birthday) { 
        let year = Number(birthday.substr(0, 4));
        var month = Number(birthday.substr(5, 2)) - 1;
        var day = Number(birthday.substr(8, 2));
        console.log("birthdy",birthday, year,month,day);
        var today = new Date();
        var age = today.getFullYear() - year;
        if (today.getMonth() < month || (today.getMonth() == month && today.getDate() < day)) {
        age--;
        }
        return age
    },
    reload(){
        location.reload()
    },
    cancelUpload() {
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel('Upload cancelled by user');
                this.cleanup();
            }
    },

    cleanup() {
        this.whileUploading = false;
        this.progress = 0;
        this.cancelTokenSource = null;
    },
    }
}
</script>
<style scoped>
.progress-container {
    text-align: center;
}

.button-group {
    margin-top: 1em;
    display: flex;
    justify-content: center;
    gap: 1em;
}

.mr-2 {
    margin-right: 8px;
}
input[type="file"] {
    display: none;
}
.custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
}
.border{
    padding: 2em;
    border: 1px solid #a8a8a8;
    border-radius: 0.5em;
    max-width: 700px;
    box-sizing: border-box;
    margin: auto;
    text-align: center;
}
canvas{
  height: 280px;
  width: 280px;
}
.float-right{
    float:right !important;
}
.blue{
    color: rgb(33, 150, 243);
    margin-bottom: 16px;
}
.my-6{
margin: 12px;
}
.width{
    max-width: 700px;
}
.login-form {
  padding: 2em;
  border: 1px solid #a8a8a8;
  border-radius: .5em;
  max-width: 700px;
  box-sizing: border-box;
  margin:auto;
}
.form-title {
  margin-bottom: 26px;
}
.login-form::v-deep .formulate-input .formulate-input-element {
  max-width: none;
}
@media (min-width: 420px) {
  .double-wide {
    display: flex;
  }
  .double-wide .formulate-input {
    flex-grow: 1;
    width: calc(50% - .5em);
  }
  .double-wide .formulate-input:first-child {
    margin-right: .5em;
  }
  .double-wide .formulate-input:last-child {
    margin-left: .5em;
    margin-bottom: 1.5em !important;
  }
}
</style>